import React from 'react';
import { BtnIcon } from './styled';

const ButtonImg = ({ ...props }: any) => {
  return <BtnIcon {...props} />;
};

export default ButtonImg;
